export default __webpack_public_path__ + "static/media/alerts.f11772bb.svg";